<h1 matDialogTitle>Confirm Resending of Email</h1>

<mat-dialog-content>
    <p>You are about the mark this failed delivery as complete/handled. Do you want to resend this email to the updated recipient?</p>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button [matDialogClose]="true">Yes, Send the Email</button>
    <button mat-button [matDialogClose]="false">No, Do Not Send the Email</button>

</mat-dialog-actions>
